export default "/packs/images/google~d522927125c36b3d73102808eda75670.png";